// App.jsx - KEEPING YOUR EXACT STRUCTURE
import React, { useLayoutEffect, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/contexts/SupabaseAuthContext';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { Toaster } from '@/components/ui/toaster';

// Admin Pages
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminTestimonials from '@/pages/AdminTestimonials';
import AdminMessages from '@/pages/AdminMessages';
import AdminServices from '@/pages/AdminServices';
import AdminPortfolio from '@/pages/AdminPortfolio';
import AdminClients from '@/pages/AdminClients';
import AdminQuotes from '@/pages/AdminQuotes';
import AdminInvoices from '@/pages/AdminInvoices';

// ScrollToTop component inside the same file
const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return null;
};

// Loading component
const LoadingSpinner = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3B82F6]"></div>
  </div>
);

// Main AppContent component
const AppContent = () => {
  const [loading, setLoading] = useState(true);

  // Simulate initial app loading
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/testimonials" element={<AdminTestimonials />} />
        <Route path="/messages" element={<AdminMessages />} />
        <Route path="/services" element={<AdminServices />} />
        <Route path="/portfolio" element={<AdminPortfolio />} />
        {/* <Route path="/clients" element={<AdminClients />} /> */}
        {/* <Route path="/quotes" element={<AdminQuotes />} /> */}
        {/* <Route path="/invoices" element={<AdminInvoices />} /> */}
      </Routes>
      <Toaster />
    </>
  );
};

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ThemeProvider>
          <Router>
            <AppContent />
          </Router>
        </ThemeProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;